import { connect } from 'react-redux';
// @flow
import { compose } from 'recompose';

import Organizations from './Organizations';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Organizations);
